import {
	BillingTypeTarget,
	BillingTypeTerm,
	CurrencyType,
	SaleTypeForTerm,
	StockTypeTarget,
	StockTypeTerm,
} from "@/lib/gql/__generated__/graphql";

import { convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour } from "@/components/features/_shared/validation-schema/converter";
import { DAY_OF_THE_WEEK_LIST } from "@/components/features/items/edit/_shared/constants/day-of-the-week";

import type { ProductDayTripPlanFormModel } from "../type";

type Props = {
	hotelID: string;
	planID: string;
	queryData: ProductDayTripPlanFormModel["QueryData"];
};

export const DEFAULT_PRODUCT_DAY_TRIP_PLAN_INPUT_MODEL = ({ hotelID, planID, queryData }: Props) => {
	// 初期値に他の画面のでの設定値を使うため、queryData から必要な値を取得して代入する
	const { customEmailSetting, hotelPolicy } = queryData;
	const { reservation } = customEmailSetting;
	const { requiredPrepMillisecond, questions } = hotelPolicy;
	const { requiredPrepMillisecondBeforeDate, requiredPrepMillisecondBeforeHour } =
		convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour(requiredPrepMillisecond);

	const inputModel: ProductDayTripPlanFormModel["InputModel"] = {
		hotelID,
		planID,

		name: "",

		availableDiscountIDs: [],
		availableOptionIDs: [],
		availableRoomIDs: [],

		billingTypeTarget: BillingTypeTarget.Person,
		billingTypeTerm: BillingTypeTerm.PerDate,

		cancelPolicy: [],

		checkInAvailableDayOfTheWeek: DAY_OF_THE_WEEK_LIST.map((item) => item.value),

		checkInEnd: "",
		checkInStart: "",
		checkOut: "",

		coSleepingKidsPrice: null,

		defaultDiscountID: null,

		doNotCountKidsAsStock: false,

		emailTemplateReservation: reservation,

		inSale: false,
		isChangeOnlyOption: false,
		isCoSleepingKidsPriceActive: false,
		includedMeals: [],
		isDayTrip: false,
		isHiddenHotelQuestions: false,
		isNoAddressNeeded: false,
		isPrivate: false,
		isRequest: false,
		isRoomPriceFree: false,
		isSCConnected: false,
		isShowRoomForGuest: false,
		isUncancelable: false,
		isUnchangeable: false,

		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,
		requiredPrepMillisecond,

		mainKeyVisual: {
			bucket: "",
			fileName: null,
			key: "",
			mimeType: null,
			region: "",
		},
		keyVisuals: [],

		kidsPolicy: null,

		longStayParams: null,

		mainTarget: null,

		maxDailyStockNum: null,
		maxPeopleNumPerRoom: null,
		maxRoomNum: null,
		maxStockNum: null,
		minRoomNum: 1,
		minimumPeopleNumPerRoom: 1,

		notSendCinMail: false,
		onlyUseCreditPayment: false,
		onlyUseLocalPayment: false,

		price: {
			amount: 0,
			currencyType: CurrencyType.Jpy,
		},

		questions,

		requiredOptionIDs: [],

		requiredOptionGroupIDs: [],

		roomChangeDisable: false,

		saleEnd: null,
		saleStart: null,
		saleStartBeforeDate: null,
		saleTypeForTerm: SaleTypeForTerm.Always,
		shortStayParams: null,

		staticPriceParams: null,

		stayableDayOfTheWeek: DAY_OF_THE_WEEK_LIST.map((item) => item.value),
		stayableEnd: null,
		stayableStart: null,
		stockTypeTarget: StockTypeTarget.Room,
		stockTypeTerm: StockTypeTerm.PerDate,
		// forReservation: {
		atCreated: {
			text: "",
			override: false,
		},
		atUpdated: {
			text: "",
			override: false,
		},
		atCanceled: {
			text: "",
			override: false,
		},
		atCheckInBefore_00days: {
			text: "",
			shouldSendEmail: false,
			override: false,
		},
		atCheckInBefore_01days: {
			text: "",
			shouldSendEmail: false,
			override: false,
		},
		atCheckInBefore_07days: {
			text: "",
			shouldSendEmail: false,
			override: false,
		},
		atCheckOutAfter_01days: {
			text: "",
			shouldSendEmail: false,
			override: false,
		},
		// },
	} satisfies ProductDayTripPlanFormModel["InputModel"];

	return inputModel;
};
